export default class MinCostPerSquareFootLookup {
    public broadLineOfBusinessCode: string | null | undefined = null; 
    public state: string | null | undefined = null;
    public constructionTypeCode: string | null | undefined = null;
    public versionId: number = 1;
    public constructor() {
    }
}